// src/components/frontend/Committee.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, Badge, Button, Form, InputGroup, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faUserTie,
    faUserGraduate,
    faGavel,
    faMoneyBillWave,
    faHandshake,
    faSearch,
    faFilter,
    faChevronDown,
    faChevronUp,
    faBuilding,
    faUser,
    faIdCard,
    faMapMarkerAlt,
    faUserCircle
} from '@fortawesome/free-solid-svg-icons';

const Committee = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filterState, setFilterState] = useState('All');
    const [showCoreCommittee, setShowCoreCommittee] = useState(true);
    const [showDistrictCommittee, setShowDistrictCommittee] = useState(false);

    // Committee Data Structure with Images
    const committeeData = {
         nationalCommittee: [
                    { id: 1, name: 'Nagabhushan', position: 'President', image: '/assets/img/members/nagabhushan.jpeg' },
                    { id: 2, name: 'Name', position: 'Vice President', image: faUserTie },
                    { id: 3, name: 'Name', position: 'General Secretary', image: faUserTie },
                     { id: 4, name: 'Name', position: 'Secretary', image: faUserTie },
                      { id: 5, name: 'Hemakshi', position: 'Treasurer', image: '/assets/img/members/Hema.jpeg' },
                    { id: 6, name: 'Name', position: 'Legal Advisor', image: faUserTie },
                   
                    
                    
                    
                    { id: 7, name: 'Name', position: 'Law Secretary', image: faUserTie },
                    { id: 8, name: 'Name', position: 'Joint Secretary', image: faUserTie },
                    { id: 9, name: 'Kavya', position: 'Executive Member', image: '/assets/img/members/Kaavya.jpeg' },
                ],
       
    };

    // Filter and Search Logic
    const getFilteredMembers = () => {
        let members = committeeData.coreCommittee;
        if (filterState !== 'All') {
            members = members.filter(member =>
                member.name.toLowerCase().includes(filterState.toLowerCase())
            );
        }
        if (searchTerm) {
            members = members.filter(member =>
                member.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        return members;
    };

    const filteredMembers = getFilteredMembers();

    // Helper function to render member image or fallback
    const renderMemberImage = (imagePath, name, size = '80px') => {
        return (
            <Image
                src={imagePath}
                alt={name}
                roundedCircle
                style={{
                    width: size,
                    height: size,
                    objectFit: 'cover',
                    border: '3px solid #1868b8',
                    padding: '3px',
                    backgroundColor: '#fff'
                }}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    // Show fallback icon if image fails to load
                    const parent = e.target.parentNode;
                    const fallbackIcon = document.createElement('div');
                    fallbackIcon.innerHTML = `<svg class="text-secondary" style="width: ${size}; height: ${size};" viewBox="0 0 24 24"><path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>`;
                    parent.appendChild(fallbackIcon);
                }}
            />
        );
    };

    return (
        <section className="py-5" style={{ backgroundColor: '#e3f2fd' }}>
            <Container>
                {/* Page Header */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold">
                            <FontAwesomeIcon icon={faUsers} className="text-primary me-3" />
                            Our Committee
                        </h1>
                        <div className="divider mx-auto" style={{ width: '80px', height: '4px', background: 'linear-gradient(90deg, #0056b3, #007bff)', marginBottom: '1rem' }} />
                        <p className="lead text-muted">
                            Meet the dedicated team leading the Media Association
                        </p>
                    </Col>
                </Row>

                {/* National Committee */}
                <Row className="mb-5">
                    <Col>
                        <h2 className="fw-bold mb-4 pb-2 border-bottom border-primary">
                            <FontAwesomeIcon icon={faBuilding} className="text-primary me-2" />
                            Committee Members
                        </h2>
                        <Row xs={1} md={2} lg={3} className="g-4">
                            {committeeData.nationalCommittee.map((member) => (
                                <Col key={member.id}>
                                    <Card className="h-100 shadow-sm border-0 hover-shadow transition text-center">
                                        <Card.Body className="p-4">
                                            <div className="mb-3 d-flex justify-content-center">
                                                {renderMemberImage(member.image, member.name, '100px')}
                                            </div>
                                            <h5 className="fw-bold mb-1">{member.name}</h5>
                                            <Badge bg="primary" className="px-3 py-2 rounded-pill">
                                                {member.position}
                                            </Badge>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>

                

                

               
            </Container>

            {/* Custom CSS for hover effects */}
            <style jsx>{`
                .hover-shadow {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-shadow:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
                }
                .transition {
                    transition: all 0.3s ease;
                }
            `}</style>
        </section>
    );
};

export default Committee;